import React from 'react';
import TooltipTrigger from 'react-popper-tooltip';
import PropTypes from 'prop-types'
import { Text } from 'components/atoms'

import 'assets/styles/Tooltip.css'

const Tooltip = ({
  children, tooltip, hideArrow, ...props
}) => (
  <TooltipTrigger
    {...props}
    tooltip={({
      arrowRef,
      tooltipRef,
      getArrowProps,
      getTooltipProps,
      placement
    }) => (
      <div
        {...getTooltipProps({
          ref: tooltipRef,
          className: 'tooltip-container'
        })}
      >
        {!hideArrow && (
          <div
            {...getArrowProps({
              ref: arrowRef,
              className: 'tooltip-arrow',
              'data-placement': placement
            })}
          />
        )}
        <Text modifiers={['xs', 'inverse', 'weightBase', 'tooltip']}>
          {tooltip}
        </Text>
      </div>
    )}
  >
    {({ getTriggerProps, triggerRef }) => (
      <span
        {...getTriggerProps({
          ref: triggerRef,
          className: 'trigger'
        })}
      >
        {children}
      </span>
    )}
  </TooltipTrigger>
);

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.string,
  hideArrow: PropTypes.bool,
  delayShow: PropTypes.number,
}

Tooltip.defaultProps = {
  tooltip: 'Tooltip goes here',
  hideArrow: true,
  className: '',
  delayShow: 50,
}

export default Tooltip
